// extracted by mini-css-extract-plugin
export default {"component":"robot_component__n7grz","login":"robot_login__+cXJb","loader":"robot_loader__62cIs","row":"robot_row__m9a44","robot":"robot_robot__UGYQg"};